import { useContext, useEffect, useState } from "react";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { ContainerPuntoControl } from "./localStyle";
import {
  wsGetPuntoControlTexto,
  wsPostTrazaPuntoControl,
} from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import puntoControlImage from "_+_Portal/assets/images/generico/puntoControl.png";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { PortalContext } from "_+_Portal/context/Provider";
import { GlobalContext } from "global/context/Provider";
import { useHistory } from "react-router";
import { logoutApp } from "global/context/action/auth/logoutApp";
import { getLocalStorage } from "global/utils/safeJsonParse";

const PuntoControl = ({ turnoActual }) => {
  //#region --------- context ---------------
  const {
    puntoControlState,
    turnosSeleccionadosState,
    textosAutoCheckinState,
    resetAutoterminalContext,
  } = useContext(AutocheckContext);
  const { selectDropDownState, resetPortalContext } = useContext(PortalContext);
  const { authDispatch, authState, resetGlobalContext } =
    useContext(GlobalContext);
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------
  const history = useHistory();
  const dataViewDefault = {
    nombre: "",
    descripcion:
      "No podés continuar la recepción por este medio. Por favor realizá la fila para ser atendido por un colaborador.",
    verLogo: true,
  };
  const [dataView, setDataView] = useState(dataViewDefault);
  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados?.data ?? [];
  const pacienteElegido =
    selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente;

  const pacienteCodigo = pacienteElegido
    ? pacienteElegido.codigo
    : authState?.auth?.data?.paciente?.codigo;

  const config = getLocalStorage("config", {});
  let sectorTurno = config?.sectorTurno;
  let opcResetContext = config?.opcResetContext;
  let idCentroTag = getLocalStorage("dataComplete");
  let idTerminal = getLocalStorage("idTerminal");
  const turno = listTurnosSeleccionado[turnoActual];
  const idTipo = puntoControlState.puntoControl.idTipo;
  const mensajeError = puntoControlState.puntoControl.mensajeError;
  const textosAutoCheckin = textosAutoCheckinState?.textosAutoCheckin?.data;
  const puntoControlText = textosAutoCheckin?.puntoControl;
  const puntoControlEfectivoText = textosAutoCheckin?.puntoControlEfectivo;
  //#endregion --------- constants ---------------
  //#region  ----------- funciones ---------------
  const nextStepPost = (isCorrect) => {
    if (isCorrect) {
      // if (puntoControlState.puntoControl.idTipo > 0 && turno) {
      //   wsGetPuntoControlTexto(
      //     puntoControlState.puntoControl.idTipo,
      //     turno.idRecepcion,
      //     turno.idCentro,
      //   )((isCorrect, data) => nextStepGet(isCorrect, data));
      // } else {
      setDataView(dataViewDefault);
      // }
    }
  };
  const nextStepGet = (isCorrect, data) => {
    if (isCorrect) {
      const dataPC = {
        ...data,
        verLogo: true,
      };
      setDataView(dataPC);
    } else {
      if (puntoControlText) {
        setDataView(puntoControlText);
      } else {
        setDataView(idTipo === 7 ? puntoControlEfectivoText : dataViewDefault);
      }
    }
  };
  const handleVolver = () => {
    if (opcResetContext) {
      resetGlobalContext(0);
      resetAutoterminalContext(0);
      history.push("/");
    } else {
      logoutApp(history, resetPortalContext)(authDispatch);
    }
  };
  //#endregion --------- funciones ---------------
  //#region  ----------- useEffect ---------------
  useEffect(() => {
    const fecha = new Date().toISOString();
    const dto = {
      idtipo: idTipo ? idTipo : 1,
      fechaalta: fecha,
      idpaciente: Number(pacienteCodigo),
      idsectoralta: Number(sectorTurno),
      idterminal: idCentroTag?.idCentro,
      idturno: turno?.idturno ? turno.idturno : -1,
      idprotocolo: turno?.idProtocolo ? turno.idProtocolo : -1,
    };
    wsPostTrazaPuntoControl(dto)(nextStepPost);
  }, []);
  //#endregion  -------- useEffect ---------------

  return (
    <LayoutPasos
      volverTo={"/autocheckin/resumen"}
      handleClick={handleVolver}
      type={"no-circle"}
      title={"ATENCIÓN"}
    >
      <ContainerPuntoControl
        initial={{ opacity: 0, y: -90 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.4 }}
        $isTerminal={idTerminal}
      >
        <h1 dangerouslySetInnerHTML={{ __html: dataView?.nombre }} />
        {idTipo !== 22 && (
          <span dangerouslySetInnerHTML={{ __html: dataView?.descripcion }} />
        )}
        {mensajeError && (
          <span
            className="mensaje-error-endpoint"
            dangerouslySetInnerHTML={{ __html: `Detalle: ${mensajeError}` }}
          />
        )}
        {dataView?.verLogo ? (
          <img src={puntoControlImage} alt="Icono ilustrativo" />
        ) : (
          ""
        )}
        <button onClick={handleVolver} className="danger">
          Salir
        </button>
      </ContainerPuntoControl>
    </LayoutPasos>
  );
};

export default PuntoControl;
